import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { ButtonModule } from "primeng/button";
import { UserService } from "../../services/user.service";

@Component({
  selector: "app-unauthorized",
  imports: [TranslocoDirective, ButtonModule],
  templateUrl: "./unauthorized.component.html",
  styleUrl: "./unauthorized.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {
  constructor(private userService: UserService) {}

  logout(): void {
    this.userService.logout().subscribe();
  }
}
